i<template>
  <div>
    <h1>
      <span style="margin-right: 20px">选择审批流程</span>
      <el-select
        v-model="approvalFlowSelect"
        size="mini"
        placeholder="请选择审批流程"
        @change="handleChangeApprovalFlow"  
      >
        <el-option
          v-for="(v, index) in approvalFlowList"
          :key="index"
          :value="v.flowId"
          :label="v.flowName"
        ></el-option>
      </el-select>
      <span 
        style="
          margin-left: 20px;
          font-weight: 400;
          font-size: 12px;
        "
      >
        无可用流程，
        <span
          style="
          color: #ec1c1e;
          cursor: pointer;" 
          @click="$router.push({path:'/console/flow'})">
          立刻设置
        </span>
      </span>
    </h1>
    <div class="f-center2">
      <div class="bow">
        <div
          v-if="flows.length > 0"
          style="
            border: 1px solid rgba(229, 229, 229, 1);
            border-radius: 4px;
            margin-top: 12px;
          "
        >
          <div style="position: relative">
            <div class="men-box">
              <div v-for="(user,i) of flows" :key="user.emplId" class="mens-sty">
                <p class="men-item">
                  <img src="/images/web/p-default.png" width="50px" height="50px" alt />
                  <span :title="user.name" class="name-warp">
                    {{
                    user.name
                    }}
                  </span>
                </p>
                <!-- 钉钉流程 flowType 1:顺序审（多层，每层一个），2：会审（单层，一层多个） -->
                <i
                  class="icon icon-audit-jiantou32"
                  v-if="flows.length > i+1 && flowInfo.flowType === 1"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { dingtalkApi } from "../../../../assets/js/http-serve/dingtalkApi";
export default {
  data () {
    // 这里存放数据
    return {
      approvalFlowList: [],
      approvalFlowSelect: undefined,
      flows: [],
      flowInfo: {}
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    /** 获取流程列表 */
    async getFlowList () {
      const dingtokenInfo = JSON.parse(sessionStorage.getItem("dingloginInfo"));
      const dingInfo = {
        corpId: dingtokenInfo.dingTalkCorpId,
        dingTalkUserId: dingtokenInfo.dingTalkUserId
      };
      let param = Object.assign(dingInfo, { status: 0 });
      let res = await dingtalkApi.workflowList(param);
      if (!res.success) {
        return this.$message.error(res.description || "查询数据失败");
      }
      this.approvalFlowList = res.data;
    },
    handleChangeApprovalFlow (val) {
      const selectFlow = this.approvalFlowList.filter(
        flow => flow.flowId === val
      );
      const flowNodes = selectFlow.length ? selectFlow[0].nodes : [];
      this.flowInfo = selectFlow.length ? selectFlow[0] : {}
      let _nodes = [];
      flowNodes.length &&
        flowNodes.map(item => {
          const users = item.userApproveUsers;
          users.map(user => {
            _nodes.push(user);
          });
        });
      this.flows = _nodes;
      this.$emit("flowSelectChange", selectFlow);
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () { },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.getFlowList();
  }
};
</script>

<style lang="less" scoped>
.men-box {
  display: flex;
  overflow-x: auto;
  .mens-sty {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    > i {
      width: 2vw;
    }
  }
  .men-item {
    width: 78px;
    margin: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    .name-warp {
      width: 66px;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  .item-close {
    display: inline-block;
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    right: 0;
  }
}
.f-top {
  background-color: #ffffff;
  margin-bottom: 20px;

  .el-form-item {
    margin-bottom: 0;
  }

  .el-row {
    padding: 20px 30px 20px 20px;
  }
}
.f-center2 {
  .f-top();
}
</style>



// WEBPACK FOOTER //
// pages/initiation/components/dingTalkuse/flowPath.vue